import { databases } from "@/lib/appwrite";
import { calculateLeaveDuration } from "@/requests/leaves/lib/calculateLeaveDuration";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const LEAVES_COLLECTION_ID = import.meta.env.VITE_LEAVES_REQUESTS_COLLECTION_ID;

export interface UpdateLeaveRequestParams {
    requestId: string;
    startDate: Date;
    endDate: Date;
    allDay: boolean;
    comment?: string;
    title: string;
}

export async function updateLeaveRequest(params: UpdateLeaveRequestParams) {
    try {
        const { requestId, startDate, endDate, allDay, comment = "", title } = params;

        const totalDuration = calculateLeaveDuration(startDate, endDate, allDay);

        if (totalDuration <= 0) {
            throw new Error("La duración calculada es 0. Verifica las fechas.");
        }

        await databases.updateDocument(
            DATABASE_ID,
            LEAVES_COLLECTION_ID,
            requestId,
            {
                title,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
                allDay,
                comment,
                totalDuration,
                status: "pending",
                statusByRrhh: "pending",
                approvedById: null,
                idRejectedByRrhh: null,
                rejectionReasonByRrhh: null,
            }
        );

        return { success: true, message: "Solicitud actualizada correctamente" };
    } catch (error) {
        console.error("Error updating leave request:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Error desconocido"
        };
    }
}